"use strict";
var __spreadArray = (this && this.__spreadArray) || function (to, from) {
    for (var i = 0, il = from.length, j = to.length; i < il; i++, j++)
        to[j] = from[i];
    return to;
};
Object.defineProperty(exports, "__esModule", { value: true });
var GeneralRoutes_1 = require("./GeneralRoutes");
/*
* Permission is required, otherwise the route will not be rendered.
* Set showInMenu to true if you want to add this item to the submenu.
*/
exports.default = __spreadArray([], GeneralRoutes_1.GeneralRoutes);
//# sourceMappingURL=PrivateRoutesConfig.js.map